/**
 * Lecture de la formule du compte depuis `GET /api/chouette/me`.
 *
 * `is_plus` est la source de vérité ; `plan_code` reste un repli défensif
 * si jamais un backend plus ancien ne l'envoie pas encore.
 *
 * Aucune notion de crédits ici : côté parent, la seule question est
 * « Chouette+ est-il actif ? » (décision produit du 2026-09-21).
 */
import type { Me } from "./types";

export function isPlus(me: Me | null | undefined): boolean {
  if (!me) return false;
  if (typeof me.is_plus === "boolean") return me.is_plus;
  const code = me.plan_code?.trim().toLowerCase();
  if (!code) return false;
  return code !== "free" && code !== "gratuit";
}
